import moment from 'moment'

export default function validators() {
  return {
    validateLicenseStartDate(licenseStartDate) {
      var startDate = new Date(licenseStartDate)
      var cutoffDate = new Date(moment(new Date()).format('YYYY-MM-DD'))
      if (isNaN(startDate.getTime())) {
        return {
          OK: false,
          message: "Start date is not formatted correctly. Should be in the form of 'YYYY-MM-DD'."
        }
      } else if (startDate.getTime() < cutoffDate.getTime()) {
        return { OK: false, message: 'Start date cannot be older than today.' }
      }
      return { OK: true }
    }
  }
}
